interface ErrorOptions {
  throw?: boolean;
}

export const error = (message: string, options: ErrorOptions = {}): void => {
  const doThrow = typeof options.throw !== 'undefined' ? options.throw : true;
  if (process.env.NODE_ENV !== 'production') {
    if (doThrow) throw new Error(message);
    console.error(message);
  } else {
    if (doThrow) throw new Error(message);
    console.error(message);
  }
};

export const warn = (message: string) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(message);
  }
};
